import Typing from "react-typing-effect";
import { Layout } from "antd";
import { Link } from "react-router-dom";
import PageBackground from "../components/PageBackground";

const { Content } = Layout;

const stats = [
  { value: "5M+", label: "Users served" },
  { value: "90%+", label: "Search perf gain" },
  { value: "New", label: "Role at Stripe" },
];

function Home() {
  return (
    <Content className="relative overflow-hidden">
      <PageBackground />

      <section className="page-shell relative z-10 mx-auto flex w-full max-w-7xl items-center pt-6 pb-12 md:pt-10 md:pb-20">
        <div className="grid w-full grid-cols-1 items-center gap-10 md:grid-cols-[1.15fr_0.85fr] md:gap-16 lg:gap-20">
          <div className="order-2 text-center md:order-1 md:text-left">
            <p className="mb-3 inline-flex items-center rounded-full bg-brand-50 px-4 py-1.5 text-sm font-medium text-brand-700 ring-1 ring-brand-200/60 dark:bg-brand-950 dark:text-brand-300 dark:ring-brand-800">
              Vancouver, Canada
            </p>

            <h1 className="font-display text-4xl font-bold leading-tight text-ink-900 dark:text-ink-50 md:text-5xl lg:text-6xl">
              Hi!{" "}
              <Typing
                className="inline-block"
                text={["I'm Julian Boyko"]}
                typingDelay={1350}
                speed={50}
                eraseDelay={5000000}
                cursorClassName="text-brand-600"
                displayTextRenderer={(text) => {
                  return (
                    <>
                      {text.split(" ").map((word, index) => {
                        if (word === "Julian" || word === "Boyko") {
                          return (
                            <span
                              key={index}
                              className="bg-gradient-to-r from-brand-600 to-sky-500 bg-clip-text text-transparent"
                            >
                              {word}{" "}
                            </span>
                          );
                        }
                        return <span key={index}>{word} </span>;
                      })}
                    </>
                  );
                }}
              />
            </h1>

            <h2 className="mt-4 text-xl leading-relaxed text-ink-600 dark:text-ink-300 md:text-2xl lg:text-3xl">
              I build{" "}
              <span className="font-semibold text-ink-900 dark:text-ink-100">
                scalable systems
              </span>{" "}
              as a{" "}
              <span className="font-semibold text-brand-600 dark:text-brand-400">
                Software Engineer
              </span>
              .
            </h2>

            <p className="mx-auto mt-4 max-w-xl text-base text-ink-500 dark:text-ink-400 md:mx-0 md:text-lg">
              React, .NET, microservices, and cloud infrastructure — shipped
              to millions of users — now joining Stripe.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:gap-4">
              <Link to="/resume" className="btn-primary sm:min-w-[11rem]">
                See my resume
              </Link>
              <Link to="/about" className="btn-secondary sm:min-w-[11rem]">
                More about me
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-3 border-t border-ink-200/80 pt-8 dark:border-ink-700/80 sm:gap-6">
              {stats.map(({ value, label }) => (
                <div key={label} className="text-center md:text-left">
                  <dt className="font-display text-2xl font-bold text-brand-600 dark:text-brand-400 sm:text-3xl">
                    {value}
                  </dt>
                  <dd className="mt-1 text-xs text-ink-500 dark:text-ink-400 sm:text-sm">
                    {label}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="order-1 flex justify-center md:order-2 md:justify-end">
            <div className="photo-ring animate-pulse-ring">
              <div className="photo-ring-inner">
                <img
                  src="/images/imageofme.jpg"
                  alt="Julian Boyko"
                  className="h-56 w-56 rounded-full object-cover sm:h-64 sm:w-64 md:h-80 md:w-80 lg:h-[22rem] lg:w-[22rem]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Content>
  );
}

export default Home;
